import styled from 'styled-components';
import { PhotoCarouselSlideMixin } from '../../mixins/components/PhotoCarouselSlideMixin';
export var StyledPhotoCarouselSlide = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPhotoCarouselSlide",
  componentId: "c11n-8-111-1__sc-jwte3-0"
})(["", ""], PhotoCarouselSlideMixin);